import { Button, Flex } from "@mantine/core";
import { OrderList } from "../OrderList/OrderList";
import { IconDownload, IconFileDownload } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import classes from "./ProfileContent.module.css";

export default function ProfileContent(): React.JSX.Element {
  const { t } = useTranslation("translation");
  return (
    <>
      <Flex
        className={classes.flexContainer}
        direction={{ base: 'column', sm: 'row' }}
        gap={{ base: 'sm', sm: 'lg' }}
        justify={{ sm: 'center' }}
      >
        <Button variant="gradient" component="a" href="https://accsolutions.de/downloads/acdrive/release/"
                gradient={{ from: "#76c425", to: "#3a6410" }}
                size="md" className={classes.control}>{t("general.downloadDrive")}<IconDownload /></Button>
        <Button variant="gradient" component="a" href="" disabled
                gradient={{ from: "#76c425", to: "#3a6410" }}
                size="md" className={classes.control}>{t("general.downloadManual")}<IconFileDownload /></Button>
      </Flex>
      {process.env.NODE_ENV === 'development' ? (
        <OrderList />
      ) : (
        <OrderList />
      )}
    </>
  );
}
